export default interface ITab<T = string> {
  name: string;
  value: T;
  isUpdated?: boolean;
  path?: string;
}

export enum TabValues {
  ACTIVITY = "activity",
  DETAILS = "details",
  COMMENTS = "comments"
}
